// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/router'
import './style/common.less';
import './util/jsfun';
// import axios from '../node_modules/axios'
import axios from './router/axios';
Vue.prototype.$axios = axios;
import store from './store';
//引入 element-ui 库/样式，并使用
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
 

Vue.config.productionTip = false
// console.log( router, "----router111" )
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js